import React from "react";
import { Box, Image, Flex, Text, Heading, Grid } from "theme-ui";
import { colors, typography } from "../../styles/theme";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const EcosystemCard = ({
  tileTheme,
  name,
  bio,
  image,
  imageUrl,
  ctaTitle,
  onCTAClick,
}) => {
  return (
    <Flex sx={{ backgroundColor: tileTheme, ...cardOuterContainerStyles }}>
      <Box sx={imageContainer}>
        {imageUrl && <Image src={imageUrl} alt="Profile Photo" />}
        {image && (
          <GatsbyImage
            image={getImage(image)}
            alt="profileCard image"
            imgStyle={imageStyle}
            className="card-image"
            sx={{ objectFit: "cover" }}
          />
        )}
      </Box>
      <Flex
        sx={{
          flexDirection: "column",
          mx: "1.5rem",
          textAlign: "center",
          mb: "1.5rem",
        }}
      >
        <Text as="h3" sx={{ ...typography.h3, mb: "0.5rem" }}>
          {name}
        </Text>
        <Text
          as="p"
          sx={{ ...typography.h7, p: { m: 0 } }}
          dangerouslySetInnerHTML={{ __html: bio }}
        />
      </Flex>
      {ctaTitle && (
        <Text onClick={onCTAClick} sx={ctaStyle}>
          {ctaTitle}
        </Text>
      )}
    </Flex>
  );
};

const EcosystemSection = ({
  ecosystemSectionTitle,
  ecosystemSectionDescription,
  ecosystems,
}) => {
  const onClick = (link) => {
    window.open(link, "_blank", "noopener,noreferrer");
  };
  return (
    <Flex sx={wrapperContainer}>
      <Heading
        as="h2"
        sx={headingContainerStyles}
        dangerouslySetInnerHTML={{ __html: ecosystemSectionTitle }}
      />
      <Text
        sx={{
          textAlign: "center",
          ...typography.textMd400,
          mb: ["3rem", "3rem", "4rem", "4.438rem"],
          px: ["1rem", "1rem", "auto", "auto"],
        }}
        dangerouslySetInnerHTML={{ __html: ecosystemSectionDescription }}
      />
      <Grid columns={[1, 1, 1, 3]} gap={[24, 24, 32, 48]} sx={gridStyles}>
        {ecosystems.length > 0 &&
          ecosystems.map((ecosystem, index) => {
            return (
              <EcosystemCard
                key={`ecosystemcard-${index}`}
                name={ecosystem.title}
                bio={ecosystem.backContent}
                image={ecosystem.cardImages[0]}
                ctaTitle="Know More"
                onCTAClick={() => onClick(ecosystem?.learnMoreUrl)}
                tileTheme={colors[ecosystem?.backgroundColor]}
              />
            );
          })}
      </Grid>
    </Flex>
  );
};

const {
  wrapperContainer,
  headingContainerStyles,
  gridStyles,
  cardOuterContainerStyles,
  imageContainer,
  ctaStyle,
} = {
  wrapperContainer: {
    mb: ["4rem", "4rem", "7rem", "7rem"],
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "transparent",
  },
  headingContainerStyles: {
    textAlign: "center",
    ...typography.h2,
    mb: "1.5rem",
    p: { m: 0 },
    px: ["1rem", "1rem", "auto", "auto"],
  },
  gridStyles: {
    "@media screen and (min-width: 900px) and (max-width: 1250px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
  },
  cardOuterContainerStyles: {
    flexDirection: "column",
    width: ["23.125rem", "23.125rem", "30rem", "23.125rem"],
    py: "1.5rem",
    borderRadius: "1.25rem",
    alignItems: "center",
  },
  imageContainer: {
    width: "17.5rem",
    height: "17.5rem",
    margin: "auto",
    p: "1.25rem",
    backgroundColor: colors.white,
    borderRadius: "0.75rem",
    mb: "1.5rem",
    mx: "2.813rem",
    mt: 0,
  },
  ctaStyle: {
    ...typography.h5,
    textAlign: "center",
    color: colors.primaryMain,
    "&:hover": {
      cursor: "pointer",
    },
  },
};

const imageStyle = {
  borderRadius: "1rem",
  objectFit: "cover",
  width: "100%",
  height: "100%",
};

export default EcosystemSection;
